




























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Form, Message, MessageBox } from 'element-ui'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import $Api from '@api'
import { PayRequestRecord, ChannelList, PayRequestRecordStatus, DataSource, RequestType } from '@/api/model/repayment'
import { translate, DateTime } from '@/utils/filters'
import { finalize } from 'rxjs/operators'
import ManualForm from '@/views/subject/repayment/unpaid/form/ManualForm.vue'
import PartialForm from '@/views/subject/repayment/unpaid/form/PartialForm.vue'
import SettlementForm from '@/views/subject/repayment/unpaid/form/SettlementForm.vue'
import store from '@/store'
import RepamentImgDialog from '@/views/subject/repayment/tallybill/RepamentImg.vue'

@Component({
    components: {
        SearchForm,
        TableForm,
        ManualForm,
        PartialForm,
        SettlementForm,
        RepamentImgDialog
    }
})
export default class extends Vue {
    fileList = [];
    fileUrl = '';
    ChannelIdOption: { label: string; value: ChannelList }[] = [
        {
            label: translate('STP'),
            value: ChannelList.STP
        },
        {
            label: translate('conektaPay'),
            value: ChannelList.conektaPay
        },
        {
            label: translate('openPay'),
            value: ChannelList.openPay
        }
    ]

    StatusOptions: { label: string; value: PayRequestRecordStatus }[] = [
        {
            label: translate('未处理'),
            value: PayRequestRecordStatus.NoHandle
        },
        {
            label: translate('已处理'),
            value: PayRequestRecordStatus.Processed
        },
        {
            label: translate('处理失败'),
            value: PayRequestRecordStatus.FAIL
        }
    ]

    RequestTypeOption: { label: string; value: RequestType }[] = [
        {
            label: translate('请求'),
            value: RequestType.REQUEST
        },
        {
            label: translate('查询'),
            value: RequestType.SEARCH
        },
        {
            label: translate('回调'),
            value: RequestType.CALL
        }
    ]

    dataSourceOptions: { label: string; value: DataSource }[] = [
        {
            label: translate('系统'),
            value: DataSource.thirdCall
        },
        {
            label: translate('手动导入'),
            value: DataSource.handImport
        }
    ]

    cacheData = {};
    dialogTipFormVisible = false
    tableData: PayRequestRecord[] = []
    shouldTableLoading = false
    total = 0
    show = false
    shouldTimeDateValue = null
    loading = false;
    dateTime = DateTime
    defaultTime = ['00:00:00', '23:59:59']

    searchForm: { [key: string]: any } = {
        current: 1,
        size: 10,
        bizId: null,
        channelId: null,
        status: null,
        tallyBillType: null,
        thirdOrderNo: null,
        dataSource: null,
        type: null
    }

    uploadFileForm = {
        fileUrl: null
    }

    rules = {
        // fileUrl: [
        //     { required: true, message: '请上传文件' , trigger: 'blur' },
        // ]
    }

    created(): void {
        this.getData()
    }
    handleClose(val: boolean) {
        this.show = false
    }
    onUploadBut() {
        this.dialogTipFormVisible = true
    }
    // 上传文件
    uploadFileSubmit() {
        this.loading = true;
        (this.$refs.uploadFileForm as any).validate((valid: any) => {
            if (valid) {
                const uploads = this.$refs.upload as any
                if (uploads !== null) {
                    const uploadFileArray = uploads.uploadFiles as any[]
                    if (uploadFileArray !== null && uploadFileArray.length > 0) {
                        const formData = new FormData()
                        uploadFileArray.forEach(file2 => {
                            this.fileUrl = file2.raw
                            formData.append('file', this.fileUrl)
                        })
                        // 调用上传接口
                        $Api.repaymentService
                            .uploadMutileFile(formData)
                            .pipe(
                                finalize(() => {
                                    this.loading = false
                                })
                            )
                            .subscribe(
                                data => {
                                    Message.success('文件上传成功，当前差异记录为：' + data)
                                    this.getData()
                                    this.handleRemove()
                                    this.dialogTipFormVisible = false
                                },
                                error => {
                                    Message.error(error.message)
                                }
                            )
                    } else {
                        Message.error('请上传文件')
                        this.loading = false
                        return false
                    }
                } else {
                    this.loading = false
                    Message.error('请上传文件')
                    return false
                }
            } else {
                this.loading = false
                return false
            }
        }, () => {
            this.loading = false
        })
    }
    getData(pageQuery?: object): void {
        if (pageQuery) {
            Object.assign(this.searchForm, pageQuery)
        }
        this.shouldTableLoading = true
        const formData = this.clearEmptyProperty(this.searchForm)
        $Api.repaymentService
            .payRequestRecordPage(formData)
            .pipe(
                finalize(() => {
                    this.shouldTableLoading = false
                })
            )
            .subscribe(res => {
                this.tableData = res.records
                this.total = res.total
            })
    }
    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    onFormReset(): void {
        // The resetFields method (from SearchForm.vue) does not take effect on datePicker, need to reset manually
        this.shouldTimeDateValue = null
    }

    clearEmptyProperty(source: any): any {
        const cloneSource = Object.assign({}, source)
        Object.keys(cloneSource).forEach(key => {
            if (cloneSource[key] === '' || cloneSource[key] === null) {
                delete cloneSource[key]
            }
        })
        return cloneSource
    }

    reset(formName: string): void {
        ;(this.$refs[formName] as Form).resetFields()
    }

    @Watch('shouldTimeDateValue')
    onShouldTimeDateValueChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.shouldTimeBegin = null
            this.searchForm.shouldTimeEnd = null
        } else {
            const [shouldTimeBegin, shouldTimeEnd] = date
            this.searchForm.shouldTimeBegin = shouldTimeBegin.getTime()
            this.searchForm.shouldTimeEnd = shouldTimeEnd.getTime()
        }
    }
    handleChange(file: any, fileList: any) {
        if (fileList.length > 1) {
            fileList.splice(0, 1)
        }
        const isJPG = file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.raw.type === 'application/vnd.ms-excel'
        if (!isJPG) {
            this.$message.error('请选择xlsx或xls格式excel')
            // 清空
            this.handleRemove()
        }
    }
    // 清空
    handleRemove() {
        if (this.$refs['upload'] as any) {
            (this.$refs['upload'] as any).clearFiles()
        }
    }
}
